import downloadAppImage from '@/assets/download-app.svg';
import {BrandLogoCircle} from '@/components/brand/BrandLogoCircle';
import {useBrand} from '@/contexts/BrandContext';
import {useIsMobile, ReferencingLayout} from '@ark/web';
import {useLogEvent} from '@/hooks/useLogEvent/useLogEvent';
import {useSearchParams} from '@/hooks/useSearchParams';
import {StepContent} from '@/components/display/StepContent';
import {Box, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

export const AppRedirect = () => {
  const [showCloseButton, setShowCloseButton] = useState(false);
  const navigate = useNavigate();
  const {searchParams} = useSearchParams();
  const logEvent = useLogEvent();
  const {name: brandName, assets, resolved} = useBrand();

  const target = searchParams.target;
  const isMobile = useIsMobile();
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (target) {
      timeout = setTimeout(() => {
        setShowCloseButton(true);
      }, 10000);
      // leaving the log here as it's useful for debugging
      console.log('redirecting to', target);
      window.location.assign(target);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [target, navigate]);

  useEffect(() => {
    if (target) {
      const targetUrl = new URL(target);
      logEvent({
        name: 'App Redirect',
        data: {
          target,
          protocol: targetUrl.protocol,
          pathname: targetUrl.pathname,
          email: targetUrl.searchParams.get('email') ?? '',
        },
      });
    }
  }, [target, logEvent]);

  let content = null;
  if (!isMobile) {
    content = (
      <Typography variant="h4" textAlign="center" sx={{marginTop: 3}}>
        Please open this link on your mobile device.
      </Typography>
    );
  } else if (showCloseButton) {
    content = (
      <Typography variant="h4" textAlign="center" sx={{marginTop: 3}}>
        You can close this window.
      </Typography>
    );
  } else {
    content = (
      <Typography variant="h4" textAlign="center" sx={{marginTop: 3}}>
        You are being redirected to the {brandName} App.
      </Typography>
    );
  }

  if (!resolved) return null;

  return (
    <ReferencingLayout background={assets.tiledBackground}>
      <Box
        display="flex"
        justifyContent="center"
        sx={{
          marginTop: 2,
        }}
      >
        <BrandLogoCircle />
      </Box>
      <StepContent sx={{mx: 0, mb: 0}} overflow="hidden">
        {content}
        <img src={downloadAppImage} alt="download app" />
      </StepContent>
    </ReferencingLayout>
  );
};
